import { htzHostnames } from '@haaretz/s-consts';

export default function getSafeRedirectUrl(redirectUrl?: string | null): string | null {
  if (!redirectUrl || typeof redirectUrl !== 'string') return null;

  const trimmedUrl = redirectUrl.trim();

  if (!trimmedUrl) return null;

  try {
    const url = new URL(trimmedUrl);

    const isTrusted = htzHostnames.some(
      domain => url.hostname === domain || url.hostname.endsWith(`.${domain}`)
    );

    if (url.protocol === 'https:' && isTrusted) return url.toString();
  } catch {
    // Relative or malformed URL — fall through
  }

  return null;
}
